import React, { useRef, useState, useEffect } from 'react';
import * as cls from './powerful-insights.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { ListToggle } from '../../../ui/layouts/list-toggle/list-toggle';
import { IMG_PATH } from '../../../constants';

const items = [
  {
    icon: 'simple-5-minute-installation.svg',
    title: 'Simple 5-Minute Installation',
    text: (
      <Typography>
        Voltaware's compact sensor installs in your fuse box in 5 minutes with
        help from a certified electrician. No rewiring, no drilling required.
      </Typography>
    ),
  },
  {
    icon: 'clear-visual-energy-dashboard.svg',
    title: 'Clear, Visual Energy Dashboard',
    text: (
      <Typography>
        Understand your energy usage at a glance. Our app shows appliance usage
        breakdowns across your home, making it easy to spot power-hungry
        appliances and energy-sapping behaviours.
      </Typography>
    ),
  },
  {
    icon: 'automatic-appliance-detection.svg',
    title: 'Automatic Appliance Detection',
    text: (
      <Typography>
        Voltaware's AI algorithms identify your major home appliances, giving
        you reliable insights - from washing machines to always-on standby
        loads.
      </Typography>
    ),
  },
];

export const PowerfulInsights = () => {
  const sectionRef = useRef(null);
  const [imageAnimated, setImageAnimated] = useState(false);
  const [animatedItems, setAnimatedItems] = useState(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setImageAnimated(true);

          const contentItems = sectionRef.current?.querySelectorAll(
            `.${cls.wrapper} > div:last-child > div`,
          );
          if (contentItems) {
            const itemPairs = [];
            for (let i = 0; i < contentItems.length; i++) {
              itemPairs.push([contentItems[i]]);
            }

            itemPairs.forEach((pair, index) => {
              setTimeout(
                () => {
                  setAnimatedItems((prev) => new Set(prev).add(index));
                },
                200 + index * 300,
              );
            });
          }
        }
      },
      {
        threshold: 0.4,
        rootMargin: '-50px 0px',
      },
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <div ref={sectionRef}>
      <Typography className={cls.section__title} tag="h2">
        Simple Design, Powerful Insights
      </Typography>

      <div className={cls.wrapper}>
        <div>
          <img
            src={`${IMG_PATH}/home/powerful-insights.png`}
            alt="powerful insights in voltaware mobile app"
            className={imageAnimated ? cls.animatedImage : cls.hiddenImage}
          />
        </div>
        <div>
          <ListToggle
            animatedItems={animatedItems}
            classNameAnimated={cls.animated}
            classNameHidden={cls.hiddenRight}
            items={items}
          />
          {/* {items.map((item, index) => (
            <div
              className={`${cls.item} ${animatedItems.has(index) ? cls.animated : cls.hiddenRight} ${active === index ? cls.active : ''}`}
              key={index}
            >
              <button onClick={() => setActive(index)}>
                <span className={cls.itemLeft}>
                  <img alt="" src={`${IMG_PATH}/home/${item.icon}`} />
                  <Typography>
                    <strong>{item.title}</strong>
                  </Typography>
                </span>
                <Arrow />
              </button>
              <div className={cls.itemHidden}>
                <Typography>{item.text}</Typography>
              </div>
            </div>
          ))}*/}
        </div>
      </div>
    </div>
  );
};
